import React from 'react';
import { Spinner } from '@utilitywarehouse/hearth-react';

export const LOADER_TEST_ID = "LOADER";

const Loader: React.FC = () => (
  <Spinner size="md" data-testid={LOADER_TEST_ID}/>
);

export default Loader;
